/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Aktualisieren',
    ENERGYPERFORMANCE: 'Energieeinsparungen',
    UTILITYBILLSAVINGS: 'Kosten der Betriebsabrechnung ',
    DateFrom: 'Datum vom',
    SITES: 'Standorte',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Energiemanagement-Bewertung',
    BASELINE: 'Basislinie',
    BASELINEKEY: 'baselineConsumption',
    ACTUALKEY: 'ActualConsumption',
    SAVINGS: 'Einsparungen',
    ACTUAL: 'Actual (Ist-Wert)',
    PARTIAL_MONTH: 'Teilmonat',
    ACTUALEMISSIONS: 'Tatsächliche Emissionen',
    ACTUALEMIS: 'Tatsächliche Emiss.',
    PREVIOUSEMIS: 'Vorherige Emiss.',
    PREVIOUSEMISSIONS: 'Vorherige Emissionen',
    TOTALCONSUMPTION: 'Gesamtverbrauch',
    EMISSION: 'Emissionen',
    ACTUALAVOIDANCE: 'Tatsächliche Vermeidung',
    PREVIOUSPERIOD: 'Vorheriger Zeitraum',
    PREVIOUS: 'Vorher',
    PREVIOUSAVOIDANCE: 'Vorherige Vermeidung',
    ACTUALCOST: 'Tatsächliche Kosten',
    actualCost: 'TATSÄCHLICHER VERBRAUCH',
    BASELINECOST: 'Baseline-Kosten',
    baselineCost: 'BASELINE-VERBRAUCH',
    PREVSPER: 'VORHERIGER ZEITRAUM',
    PREVIOUSCOST: 'Vorherige Kosten',
    VIEWDETAILS: 'DETAILS ANZEIGEN',
    ADVANCED: 'Erweitert',
    BASIC: 'Basis',
    MONTHLY: 'Monatlich',
    BILLING: 'Abrechnung',
    LIVEMETER: 'Live-Zähler',
    UTILITYMETER: 'Versorgungszähler',
    LIVEREADING: 'Vor-Ort-Zähler',
    UTILITYINTERVAL: 'Versorgungsgüterintervall',
    UTILITYPROVIDERNEW: 'Versorgunggüter monatlich',
    ACTUALCONSUMPTION: 'Tatsächlicher Verbrauch',
    BASELINECONSUMPTION: 'Baseline-Verbrauch',
    PREDICTED: 'Vorhergesagt',
    Utilitycost: 'Versorgungsgüterkosten für',
    UtilityBill: 'Übersicht über die Betriebsabrechnung',
    UtilityCost: 'Kosten für Versorgungsgüter',
    ActualCost: 'Tatsächliche Kosten',
    CostPercentage: 'Kosten %',
    Electricity: 'Elektrizität',
    Gas: 'Erdgas',
    Water: 'Wasser',
    UtilityType: 'Art des Versorgungsguts',
    all: 'alle',
    electricity: 'Elektrizität',
    gas: 'Gas',
    water: 'Wasser',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Für {siteWithDataCount} der {totalSiteCount} Standorte wurden die Betriebsabrechnungen für den Energieverbrauch generiert.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Für {siteWithDataCount} der {totalSiteCount} Standorte wurden die Emissionen für die Betriebsabrechnungen generiert.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Für {siteWithDataCount} der {totalSiteCount} Standorte wurden Emissionen für Live-Messwerte generiert.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Für {siteWithDataCount} der {totalSiteCount} Standorte wurden die Betriebsabrechnungen für den Energieverbrauch generiert.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Live-Messwerte wurden für {siteWithDataCount} der {totalSiteCount} Standorte generiert.',
    UtilityTypeforselectutility: 'Art des Versorgungsguts*',
    ENABLEIDSCHECKBOX: 'IDS (Intervall-Datenservice) aktivieren',
    ENABLED: 'Aktiviert',
    DISABLED: 'Deaktiviert',
    CONVERSIONINFOMSG:
      'Bitte geben Sie Ihre Anmeldedaten an, um die Konvertierung dieser Kontonummer von einem „manuellen“ zu einem „automatischen“ Integrationstyp zu ermöglichen. Sobald die \n    Anmeldedaten verifiziert sind, wird der Integrationstyp automatisch aktualisiert. Die manuell gespeicherten Daten bleiben erhalten und die anstehenden Rechnungen \n    werden danach automatisch aktualisiert.',
    CO2: 'CO2',
    CARBON: 'CO2({unit})',
    CARBONNOUNIT: 'Kohlenstoff',
    CARBONEMISSION: 'CO2-Emissionen',
    METERDATA1: 'Zählerdaten',
    DATANEEDED: 'Benötigte Daten',
    METERDATA: 'Zählerdaten',
    METERDATASUBTITLE:
      'Analysieren und vergleichen Sie den Zählerverbrauch durch Hochladen von historischen und/oder Daten für fehlende Zeitspannen.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'STROMVERBRAUCH',
    ELECTRICITYPERFORMANCE: 'Elektrizitätsleistung',
    Electicity:
      ' Strom-, Gas- und Wasserdaten können durch Verknüpfung mit Ihren Konten integriert werden',
    FORECAST: 'Prognose',
    ALL: 'Alle',
    ELECTRICITY: 'Elektrizität',
    GAS: 'Erdgas',
    WATER: 'Wasser',
    METER: 'ZÄHLER',
    SavingMeter: 'Einsparungen pro Zähler',
    BREAKDOWNMETER: 'Verbrauch pro Zähler',
    BREAKDOWNBYAREAS: 'Aufschlüsselung nach Bereichen',
    BREAKDOWNBYEQUIPMENTTYPE: 'Aufschlüsselung nach Gerätetyp',
    CONSUMPTIONBYUTILITIES: 'Verbrauch nach Versorgungsgütern',
    ENERGYBREAKDOWNOFUTILITY: 'Aufschlüsselung der Versorgungsgüter',
    ENERGYBREAKDOWNBYMETERS: 'Aufschlüsselung nach Zählern',
    WATERBREAKDOWNBYLIVEMETERS: 'Aufschlüsselung nach Live-Zählern',
    BREAKDOWNOFUTILITY: 'Aufschlüsselung der Kosten für Versorgungsgüter',
    breakdownUtility: 'Aufschlüsselung nach Versorgungsgütern',
    breakdownCarbon: 'Aufschlüsselung der Zähler',
    breakdownCarbonScopeOne: 'Aufschlüsselung nach Kategorie',
    breakdownFuel: 'Aufschlüsselung der Kraftstoffarten',
    breakdownAreas: 'Aufschlüsselung nach Bereichen',
    areasHeader: ' Bereiche',
    metersHeader: 'Zähler',
    areasSubHeaders:
      'Die folgende Nutzungsaufschlüsselung für Strom wurde nach Bereichen und für den ausgewählten Zeitraum durchgeführt.',
    baselinebutton: 'Baseline erstellen',
    LAST_BASELINE_TRAINED_DATE: 'Letzte Baseline geschult am',
    apply: 'Anwenden',
    back: 'Zurück',
    baselinetraning: 'Baseline-Training',
    chooseTrainingDateRange: 'Wählen Sie den Trainingsdatumsbereich',
    applyBaselineFrom: 'Baseline anwenden ab',
    historicDataTooltip:
      'Für die hochgeladenen historischen Daten ist die Baseline für die letzten 15 Tage im Dashboard und in den Berichten sichtbar.',
    excludeSpecificDateRangeQ:
      'Möchten Sie einen bestimmten Datumsbereich ausschließen?',
    excludeDateRange: 'Datumsbereich ausschließen',
    howitworks: 'Wie funktioniert dies?',
    howitworksone:
      'Alle hochgeladenen Zählerdaten werden verwendet, um ein hochwertiges Baseline-Modell zu erstellen',
    howitworkstwo:
      'Die Basisdaten werden am Dashboard und in Berichten für die letzten 15 Tage ab dem Upload-Datum angezeigt.',
    howitworksthree:
      'Um die besten Baseline-Ergebnisse zu erzielen, wird empfohlen, Daten für 12 Monate zu verwenden.',
    howitworksfour:
      'Für die Modellbildung sind mindestens 30 Tage Daten erforderlich',
    howitworksfive:
      'Baseline-Training wird auf Daten von allen Standortmessern angewendet',
    howitworkssix:
      'Wenn Sie das Baseline-Modell neu trainieren, wird das vorhandene Modell auf der Grundlage der neuen Baseline-Trainingszeitspanne ersetzt.',
    baselinedaterangeheader: 'Baseline-Trainingszeitraum auswählen',
    baselinedaterangesubheader:
      'Wählen Sie für das Baseline-Modell den Datumsbereich aus, unabhängig davon, ob ein bestimmter Zeitraum ein- oder ausgeschlossen werden soll.',
    redirectmsg1: 'Sie werden umgeleitet in',
    redirectmsg2: 'Sek.',
    uploadingmsg:
      'Bitte warten Sie, bis der Prozess des Trainings der Baseline beginnt. Sobald dieser abgeschlossen ist, werden wir Sie per E-Mail darüber informieren.',
    meterSubHeaders:
      'Die Tabelle enthält Informationen zu den Zählern am Standort und verschiedene Leistungskennzahlen.',
    breakdownCarbonSites: 'CO2-Emissionen nach Standorten ({count})',
    ENERGYUSAGE: 'Energieverbrauch',
    ENERGYUSAGECONSUMPTION: 'Verbrauch',
    USAGEConsumption: 'Verbrauch',
    WATERUSAGE: 'Wassernutzung',
    NILMTOOLTIPHEADER: 'Non-Intrusive Load Monitoring (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Energie-Desaggregierung',
    ENERGYUSAGEOVERVIEW: 'Übersicht über den Energieverbrauch',
    CONSUMPTIONOVERVIEW: 'Verbrauchsübersicht',
    LOADING: 'Laden',
    SUBMITTING: 'Absenden',
    NODATAAVAILABLE: 'Keine Daten für ausgewählten Datumszeitraum',
    UTILITYYEAROUTOFRANGE:
      'Wählen Sie den Datumsbereich innerhalb eines Jahres aus.',
    NOTSUBSCRIBED: 'Nicht abonniert',
    CONNECTIONERROR:
      'Keine Verbindung zum\nDienst. Bitte versuchen Sie es erneut',
    CONNECTIONERRORTITLE: 'Fehler bei der Verbindung!',
    WATERTOOLTIPHEADER: 'Wasserverbrauch',
    CARBONSAVINGSMETERHEADER: 'Emissionen nach Kategorie',
    CARBONKPIDETAILS: 'CO2-Emissionen für',
    ENERGYUSAGEDETAILS: 'Energieverbrauch für',
    WATERUSAGEDETAILS: 'Wassernutzung für',
    CarbonSavingMeter: 'Einsparung nach Versorgungsgut',
    SITENAMESHEADER: 'Aufschlüsselung nach Standorten',
    CARBONTOOLTIPHEADER: 'CO2-Emission',
    GASTOOLTIPHEADER: 'Energieeinsparungen bei Gas',
    ALLTOOLTIPHEADER: 'Energieeinsparungen',
    METEROVERVIEW: 'Zähler-Übersicht',
    METERANALYSIS: 'Zähleranalyse',
    ID: 'ID',
    TYPE: 'Typ',
    DEVIATION: 'Abweichung',
    HIGH: 'Hoch({unit})',
    HIGHWITHOUTUNIT: 'Hoch',
    LOW: 'Niedrig({unit})',
    LOWWITHNOUNIT: 'Niedrig',
    ENERGY: 'Energie({unit})',
    ENERGYNOUNIT: 'Energie',
    CHANGE: 'Änderung',
    CARBONTAB: 'CO2 (CO2e)',
    ENERGYTAB: 'Energie',
    WATERTAB: 'Wasser',
    EUITAB: 'EUI',
    UTILITYCOST: 'Versorgungsgut',
    actualConsumption: 'TATSÄCHLICHER VERBRAUCH',
    actualCons: 'TATSÄCHLICHER VERBRAUCH',
    baselineConsumption: 'BASELINE-VERBRAUCH',
    baselineCons: 'BASELINE-VERBRAUCH',
    ConsumptionSavingsPercentage: '% VERBR. EINSPARUNGEN',
    ConsumptionChange: 'VERBR. ÄNDERUNG',
    ConsSavings: 'VERBR. EINSPARUNGEN',
    utiltactualCost: 'TATSÄCHLICHE KOSTEN',
    utilpreviousCost: 'VORHERIGE KOSTEN',
    SavingsPercentage: 'EINSPARUNGEN %',
    utilchange: 'ÄNDERUNG',
    NODATA: 'Keine Daten',
    ENERGYKPIDETAILS: 'Elektrizitätsleistung für',
    ENERGYPERFORMANCEALL: 'Energieleistung',
    NILMENERGYUSAGE: 'Energieverbrauch',
    NILMENERGYUSAGESUBHEADER:
      'Die graphische Darstellung zeigt den Energieverbrauch der ausgewählten Zeitspanne',
    ALLKPICARDDETAILS: 'Energieleistung für',
    WATERCONSUMPTIOND: 'Wasserverbrauch für',
    ENERGYCONSUMPTIONMETER: 'Verbrauch nach Zähler',
    WATERCONSUMPTION: 'Wasserverbrauch',
    ALLUTILITIES: 'Alle Versorgungsgüter',
    ALLEnergySources: 'Alle Energiequellen',
    WaterPerformance: 'Wasserleistung',
    WaterOverview: 'Wasser-Übersicht',
    GASPERFORMANCE: 'Gasleistung für',
    GASPERFORMANCEDETAILS: 'Gasleistung',
    WATERPERFORMANCEDETAILS: 'Wasserleistung',
    SEWERAGEPERFORMANCE: 'Abwasserleistung',
    ALLSAVINGSBYUTILITY: 'BTU-Einsparungen nach Versorgungsgut',
    TOTALENERGYCOST: 'Gesamtenergiekosten',
    TOTALSAVINGS: 'Gesamteinsparungen',
    TOTALFOOTSPRINT: 'Gesamt-Footprint',
    INTEGRATIONTYPE: 'INTEGRATIONSTYP',
    UTILITYPROVIDER: 'VERSORGUNGSGUTANBIETER',
    ACCOUNTNUMBER: 'KONTONUMMER',
    STATUS: 'STATUS',
    UDSSTATUS: 'Monatlicher DS-Status',
    IDSSTATUS: 'Intervall-DS-Status',
    ACTIONS: 'MASSNAHMEN',
    SERVICESOVERVIEW: 'Services - Übersicht',
    AddService: 'SERVICE HINZUFÜGEN',
    AllServices: 'Alle Services',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Sewerage: 'Abwasser',
    ServiceProvider: 'Serviceanbieter',
    AccountNumber: 'Kontonummer',
    CANCEL: 'ABBRECHEN',
    SELECTALL: 'Alles auswählen',
    SEARCH: 'Suche',
    SHOWACCOUNTNUMBERS: 'Alle Kontonummern anzeigen',
    BACK: 'ZURÜCK',
    SUBMIT: 'ABSENDEN',
    Complete: 'ABSCHLIESSEN',
    DONE: 'FERTIG',
    Utillity: 'Versorgungsgut',
    AllUtilityService: 'Alle Versorgungsgutservices',
    Weather: 'Wetter',
    WeatherServices: 'Wetterservices',
    Weatherdata:
      'Wetterdaten können in die Verknüpfung Ihrer Konten integriert werden',
    CONFIGURE: 'KONFIGURIEREN',
    METERID: 'ZÄHLER-ID',
    SERVICETYPE: 'SERVICETYP',
    METERINGPURPOSE: 'MESSZWECK',
    SITESETTINGS: 'Standorteinstellungen',
    SERVICESINTEGRATION: 'Services',
    USERMANAGEMENT: 'Benutzerverwaltung',
    GENERALSETTINGS: 'Allgemeine Einstellungen',
    UTILITYBILLTOOLTIPHEADER: 'Betriebsabrechnung',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Versorgungsgüterleistung',
    ELECTRICITYTOOLTIPHEADER: 'Energieeinsparungen bei Elektrizität',
    WATERTOOLTIPCONTENT:
      'Vergleich des Wasserverbrauchs für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Basisjahresdaten',
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      'Kosten, berechnet für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Vorjahresdaten. Hinweis: Die Kosten werden auf der Basis von Kalendermonaten berechnet und sind nicht spezifisch in Bezug auf Versorgungsabrechnungszeiträume.',
    UTILITYBILLTOOLTIPCONTENT:
      'Verbrauch und Kosten, berechnet für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Vorjahresdaten. Hinweis: Die Kosten werden auf der Basis von Kalendermonaten berechnet und sind nicht spezifisch in Bezug auf Versorgungsabrechnungszeiträume.',
    CARBONTOOLTIPCONTENT:
      'Emissionen, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres. ',
    DATANEEDEDCONTENT:
      'Scope 1-Daten fehlen, überprüfen und aktualisieren Sie die Daten jeden Monat',
    CARBONTOOLTIPSECONDCONTENT:
      'CO2-Echtzeitberechnungen basieren auf dem Hauptzähler und die CO2-Berechnungen werden nach der Generierung der Betriebsabrechnung auf den präzisen Wert aktualisiert.',
    CARBONTOOLTIPSUTILITY:
      'Emissionen, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres. Die Berechnungen der tatsächlichen CO2-Emissionen basieren auf der bereitgestellten Betriebsabrechnung.',
    CARBONTOOLTIPLIVE:
      'Emissionen, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres vom Zähler vor Ort. Die Echtzeit-CO2-Berechnungen basieren auf dem Hauptzähler.',
    CARBONTOOLTIPINTRVAL:
      'Emissionen, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres. Die Berechnungen der tatsächlichen Kohlenstoffemissionen basieren auf Versorgungsintervalldaten.',
    ELECTRICITYTOOLTIPCONTENT:
      'Berechnung der Einsparungen beim Strom für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Basisjahresdaten',
    DATANEEDED1:
      'Unzureichende Daten - Scope-1-Daten müssen jeden Monat aktualisiert werden.',
    GASTOOLTIPCONTENT:
      'Berechnung der Einsparungen beim Gas für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Basisjahresdaten',
    ALLTOOLTIPCONTENT:
      ' Berechnung der Einsparungen für den ausgewählten Zeitraum anhand der Ist-Daten in Bezug auf die Basisjahresdaten',
    UTILITYVIEWDETAILSTOOLTIP:
      'Verbrauch und Kosten, berechnet für den ausgewählten Zeitraum anhand der tatsächlichen Daten in Bezug auf die Vorjahresdaten. Hinweis - Verbrauch und Kosten werden auf der Basis von Kalendermonaten berechnet und sind nicht spezifisch in Bezug auf Versorgungsabrechnungszeiträume.',
    EMAASENERGYUSAGETOOLTIP:
      'Verbrauch, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Basisjahresdaten.',
    EMAASENERGYUSAGETOOLTIPPREV:
      'Verbrauch, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres.',
    EMAASCONSUMPTIONTOOLTIP:
      'Der Verbrauch wird für die ausgewählte Dauer auf der Grundlage der tatsächlichen Werte im Vergleich zu den Basis- oder den Daten des Vorjahres berechnet.',
    EMAASWATEROVERVIEWTOOLTIP:
      'Verbrauch, berechnet für den ausgewählten Zeitraum auf der Grundlage der tatsächlichen Werte im Vergleich zu den Daten des Vorjahres.',
    EMAASNILMTOOLTIP:
      'Legen Sie die Aufschlüsselung des Energieverbrauchs Ihres Standorts nach Gerätetypen fest',
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Gesamt-Kosteneinsparungen bei Energieversorgungsgütern für den ausgewählten Zeitraum',
    PORTFOLIOSUMMARYEUITOOLTIP:
      'EUI ist ein Indikator für die Energieeffizienz des Designs und/oder des Betriebs eines Gebäudes. EUI wird als Energieverbrauch des Portfolios gemessen, dividiert durch die gesamten Fläche des Portfolios in einem Jahr.',
    SITESUMMARYEUITOOLTIP:
      'EUI ist ein Indikator für die Energieeffizienz des Designs und/oder des Betriebs eines Gebäudes. EUI wird als Energieaggregation des Standorts für die letzten 12 Monate gemessen, dividiert durch die Gesamtbruttofläche des Standorts.',
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (Energy Use Intensity)',
    SUMMARYEUITOOLTIPHEADERFORSITE: 'EUI (Energy Use Intensity) - {date}',
    PROVIDERLISTPLACEHOLDER: 'Suche nach Anbieterdetails',
    PORTFOLIOSUMMARYHEADER: 'CO2- und Energie - Übersicht',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Zuletzt aktualisiert am {date}',
    AIModelDetails: 'KI-Modell-Details',
    DATAUPLOAD: 'Datenupload',
    ADDFUEL: 'Kraftstoff hinzufügen',
    ADD: 'Hinzufügen',
    ADDCOMPOUND: 'Verbindung hinzufügen',
    ADDMETEREDGAS: 'Gemessenes Gas hinzufügen',
    ADDSCOPETWO: 'Geltungsbereich 2 hinzufügen',
    EXCEEDEDLIMIT: 'Max. Grenzwert bis 4 überschritten',
    DETAILS: 'Details',
    DATAUPLOADDETAILS:
      'Auf alle Funktionen zugreifen, die manuelle Eingabe/Hochladen von Datendateien erfordern',
    DATAUPLOADCECARDSUBTITLE:
      'Verfolgen Sie die Scope-1-CO2-Emissionen, um die Ziele Ihres Unternehmens bei der Nachhaltigkeitsleistung zu erreichen.',
    DATAUPLOADCARBONESUBTITLE:
      'Auf dieser Seite finden Sie eine umfassende Tabelle mit Informationen zu verschiedenen Kraftstoffen, ihren entsprechenden Mengen und den damit verbundenen CO2-Emissionsfaktoren für das ausgewählte Jahr.',
    SCOPEONETWOSUBTITLE:
      'Auf dieser Seite finden Sie eine detaillierte Tabelle, die Scope 1- (Direkte Emissionen, einschließlich stationärer Verbrennung und Kältemittel) und Scope 2- (Indirekte Emissionen aus Elektrizität) Emissionen, zusammen mit ihren Mengen und zugehörigen CO2-Emissionsfaktoren für das ausgewählte Jahr zeigt.',
    METERDATASUBHEADER:
      'Greifen Sie auf alle Ihre hochgeladenen Datendateien für Zählerdaten zu.',
    DATAMISSINGALERTS: 'Warnungen bei fehlenden Daten',
    UPLOAD: 'Massen-Upload',
    UPLOADTOPADD: 'Datei hochladen',
    PUBLISHFILE: 'Veröffentlichen',
    BASELINEFILE: 'Baseline',
    BASELINE_SUCCESS: 'Baseline-Training erfolgreich initiiert',
    UPLOADTOP: 'Hochladen',
    UPLOADFILE: 'HOCHLADEN',
    NAME: 'Name',
    DATATYPE: 'Datentyp',
    CREATEDON: 'Erstellt am',
    DATEOFUPLOAD: 'Upload-Datum',
    ALLUPLOADS: 'Alle Uploads',
    STATIONARYCOMBUSTION: 'Stationäre Verbrennung',
    REFRIGERANTS: 'Kältemittel',
    WHEATHERDATA: 'Wetterdaten',
    UTILITYBILL: 'Betriebsabrechnung',
    SCOPE2: 'Scope 2',
    METEREDGAS: 'Gemessenes Gas',
    NOFILESADDEDHEADER: 'Es wurden noch keine Dateien hinzugefügt.',
    NOFILESADDEDMESSAGE:
      'Beginnen Sie mit dem Hochladen von Wetter-, Versorgungsgut- oder Punktdaten',
    UPLOADBUTTON: 'Hochladen',
    METER_DATA: 'Zählerdaten',
    UTILITY_BILL: 'Betriebsabrechnung',
    FUEL_NAME: 'KRAFTSTOFFNAME',
    SEARCHFOR: 'Suchen',
    EnergyManagementSiteDashboardPortfolioTitle:
      'Kohlenstoff- und Energieübersicht',
    CHOOSEDATATYPEMESSAGE:
      'Wählen Sie unten einen Datentyp aus, um die Vorlage herunterzuladen und im nächsten Schritt Dateien hochzuladen.',
    UPLOADMETERDATASTEPONEMESSAGE: 'Schritt 1: Download der Zählerdatenvorlage',
    UPLOADMETERDATA: 'Zählerdaten hochladen',
    FILEUPLOADNOTE:
      'Hinweis: Es werden nur Dateien des Typs {type} akzeptiert. Die Größe der einzelnen Dateien darf {size} MB nicht überschreiten.',
    UPDATEDFILEUPLOADNOTE:
      'Hinweis: Nur CSV-Dateien werden akzeptiert und die Datei darf 5 MB nicht überschreiten',
    INSTRUCTIONSFORFILLINGTHETEMPLATE: 'Anweisungen zum Hochladen der Vorlage.',
    INSTRUCTIONTEMPLATEONE:
      'Beginnen Sie, indem Sie historische Zählerstanddaten mithilfe der bereitgestellten CSV-Vorlage hochladen.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      'Bitte stellen Sie sicher, dass die hochgeladenen Datenwerte die in RBM konfigurierte Einheit verwenden',
    INSTRUCTIONTEMPLATEFIVE:
      'Der Benutzer kann während des Uploadvorgangs maximal 10 Dateien hochladen, mit einer Gesamtdateigröße von höchstens 1,5 GB.',
    INSTRUCTIONTEMPLATETWO:
      'Der Benutzer kann Daten für maximal 2 Jahre mit einem Intervall von 1, 3, 5 oder 15 Minuten und einer Dateigröße von bis zu 1,5 GB hochladen.',
    INSTRUCTIONTEMPLATETHREE:
      'Beachten Sie, dass das Dashboard und die Berichte die historischen Zählerdaten der letzten 15 Tage anzeigen und alle hochgeladenen Zählerdaten verwendet werden, um ein hochwertiges Basismodell zu erstellen.',
    INSTRUCTIONTEMPLATEFOUR: 'Beispiel einer ausgefüllten CSV-Vorlage anzeigen',
    UPLOAD_PROGRESS_IN_TOAST:
      'Der Fortschritt des Hochladens ist im Widget unten auf dem Bildschirm zu sehen.',
    PUBLISHMODALHEADER: 'Zur Veröffentlichung bereit?',
    ERRORINPUBLISHING:
      'Beim Veröffentlichen der Dateien ist ein Fehler aufgetreten. Bitte versuchen Sie es in einiger Zeit erneut.',
    WARNINGNOTIFICATIONFORPUBLISH: 'Zurzeit werden weitere Dateien hochgeladen',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      'Möchten Sie lieber warten, bevor Sie {filesToPublish} Dateien veröffentlichen, oder möchten Sie mit der Veröffentlichung fortfahren?',
    NOTEFORPUBLISHFILE:
      'Hinweis: Wir benachrichtigen Sie nach Abschluss der Veröffentlichung per E-Mail und zeigen die historischen Zählerdaten der letzten 15 Tage nur im Dashboard/Berichten an.',
    INSTRUCTIONFORPUBLISHFILE:
      'Möchten Sie die hochgeladenen Dateien veröffentlichen?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Download Meter Data CSV Template',
    PUBLISHBUTTON: 'Ja, veröffentlichen',
    METERDATAPUBLISHINGMSG:
      'Bitte warten Sie, bis die Daten veröffentlicht werden. Wir werden Sie per E-Mail benachrichtigen, sobald dies abgeschlossen ist.',
    METERDATAUPLOADFAILED:
      'Fehler beim Hochladen von Datei: {fileName}. Bitte versuchen Sie es nach einiger Zeit erneut',
    METERDATAUPLOADSUCCESS: 'Datei: {fileName} erfolgreich hochgeladen',
    NOBUTTON: 'Nein',
    METERUPLOADINSTRUCTIONTITLE: 'Anweisungen zum Hochladen von Zählerdaten',
    METERUPLOADDOWNLOADCSV: 'CSV-Vorlage herunterladen',
    METERUPLOADDOWNLOADEXCEL: ' CSV-Vorlage herunterladen',
    METERUPLOADINSTRUCTIONONE:
      'Beginnen Sie, indem Sie historische Zählerstanddaten mithilfe der bereitgestellten CSV-Vorlage hochladen. ',
    METERUPLOADINSTRUCTIONFOUR:
      'Stellen Sie sicher, dass die heruntergeladenen Daten vom Supervisor 1,5 GB nicht überschreiten. Bitte beachten Sie die für die Datengröße vorgesehenen Voreinstellungen. ',
    METERDATAEXCELDOWNLOAD: 'Schätzung im Excel-Format herunterladen',
    METERUPLOADINSTRUCTIONTWO:
      'Nachdem Sie CSV-Dateien für alle/die gewünschten Standortzähler hochgeladen haben, klicken Sie auf die Schaltfläche „Veröffentlichen“, um historische Daten zu verarbeiten und aufzufüllen.',
    METERUPLOADINSTRUCTIONTHREE:
      'Um eine Baseline zu erstellen, klicken Sie auf „Baseline-Aktion“ und geben Sie den gewünschten Datenbereich an. Forge AI trainiert die Baseline anhand der veröffentlichen historischen Daten.',
    CHOOSEDATATYPE: 'Datentyp auswählen',
    NEXTUPLOAD: 'Nächster Upload',
    UPLOADDATA: 'Daten hochladen',
    ADDNEWFUEL: 'Neuen Kraftstoff hinzufügen zu',
    ADDNEWCOMPOUND: 'Neue Verbindung hinzufügen zu',
    MANUALINPUT: 'MANUELLE EINGABE',
    UPLOADDATACAPS: 'DATEN HOCHLADEN',
    ADDNEWFUELSUB:
      'Wählen Sie aus den Optionen unten aus, um eine Vorlage manuell einzugeben oder hochzuladen',
    SCOPEONESC: 'Stationäre Verbrennung: Kraftstoff hinzufügen',
    SCOEONEREF: 'Kältemittel: Verbindung hinzufügen',
    SCOPETWO: 'Scope 2',
    UPLOADING: 'Hochladen',
    FILES: 'Dateien',
    FILE: 'Datei',
    UPLOADINGMESSAGE1:
      'Der Fortschritt des Uploads und die Statusinformationen für diese Dateien sind in der Benachrichtigung unten in der Mitte des Bildschirms zu sehen.',
    REDIRECTMESSAGE1: 'Sie werden umgeleitet in',
    REDIRECTMESSAGE1OCR: 'Sie werden bald umgeleitet',
    REDIRECTMESSAGE2: 'Sek.',
    UPLOADFILES: 'Dateien hochladen für',
    UPLOADMETERDATASTEPTWOMESSAGE:
      'Schritt 2: Laden Sie Dateien für Zählerdaten hoch',
    UPLOADNOTE:
      'Es werden nur Dateien des Typs {type} akzeptiert und die Größe der einzelnen Dateien darf {size} MB nicht überschreiten',
    UPDATEDUPLOADNOTE:
      'Es wird nur eine CSV-Datei akzeptiert und deren Größe darf 1,5 GB nicht überschreiten',
    UPDATEDUPLOADNOTESUB: '(es ist immer nur ein Upload gleichzeitig möglich)',
    INSTRUCTIONBUTTON: 'Beispiel für gefüllte CSV-Vorlage',
    FILEUPLOADPLACEHOLDER: 'Hier Dateien ziehen und ablegen',
    SINGLEFILEUPLOADPLACEHOLDER: 'Hier Datei ziehen und ablegen',
    TOTALSIZEEXCEEDSERROR:
      'Die Gesamtgröße überschreitet den Grenzwert (1,5 GB)',
    NUMBEROFFILEALLOWED: 'Sie können bis zu 10 Dateien hochladen',
    FILEUPLOADPLACEHOLDERONLYONEFILE:
      '(es ist immer nur ein Upload gleichzeitig möglich)',
    REMOVE: 'Entfernen',
    CHOOSESERVICE: 'Service auswählen',
    CONNECT: 'Verbinden',
    NEXT: 'Weiter',
    CHOOSEUTILITYTYPE:
      'Wählen Sie für die Integration von Daten den Utility-Serviceanbieter, die Anmeldeinformationen und die Kontodetails aus.',
    CHOOSEUTILITYTYPEMANUAL:
      'Geben Sie den Serviceanbieter für Versorgungsgüter und die Kontodetails ein, um Daten zu Versorgungsgütern manuell hochzuladen.',
    EDITDETAILNOTE:
      'Geben Sie unten die korrekten Konto- und Zählerdetails ein. Klicken Sie dann auf „Absenden“, um die Daten zu aktualisieren und zu speichern.',
    EDITDETAILWHENBILLEXISTS:
      'Geben Sie unten die korrekten Konto- und Zählerdetails ein. Klicken Sie dann auf „Absenden“, um die Daten zu aktualisieren und zu speichern.',
    SEARCHPROVIDER: 'Versorgungsunternehmen suchen',
    CONTACTSUPPORT:
      'Sie können den Versorgungsgutanbieter nicht finden? Wenden Sie sich an den Support von Honeywell.',
    UTILITYPROVIDERLABEL: 'Versorgungsgutanbieter',
    SERVICEPROVIDERNAME: 'DIENSTLEISTER',
    INTEGRATIONTYPENAME: 'INTEGRATIONSTYP',
    UTILITYSERVICES: 'Versorgungsgüterservices',
    UtilityHandoffNotification:
      'Der Integrationstyp von {manualCount} Utility Service Account kann von "Manuell" auf "Automatisch" konvertiert werden. Dadurch wird die automatische Aktualisierung der Versorgungskosten ermöglicht, ohne dass Schritte von Ihnen erforderlich sind. Die Option finden Sie im Menü „Aktionen“ in der Tabelle unten.',
    UTILITYSERVICESDETAILS:
      'Integrieren und verwalten Sie Ihre zahlreichen Services, um Daten automatisch schnell und smart zu verarbeiten.',
    ADDUTILITYSERVICE: 'Versorgungsgutservice hinzufügen',
    ADDUTILITYTYPE: 'Versorgungsgut-Integrationstyp',
    AUTOMATEDTEXT:
      'Bitte geben Sie Ihre Anmeldedaten für das Konto „Versorgunggutsanbieter“ an, um den automatischen monatlichen Abruf Ihrer Betriebsabrechnungsdaten zu ermöglichen.',
    MANUALTEXT:
      'Wenn Sie nicht über die Anmeldeinformationen für Ihren Serviceanbieter verfügen, müssen Sie die Informationen zur Aktualisierung der Betriebsabrechnung jeden Monat manuell aktualisieren.',
    MANUAL: 'Manuell',
    AUTOMATED: 'Automatisiert',
    ADD_UTILITY_SERVICE: 'Versorgungsgutservice hinzufügen',
    UTILITYTYPES: 'VERSORGUNGSGUTTYPEN',
    NOACCOUNTADDEDHEADER:
      'Es wurden noch keine Versorgungsgutkonten hinzugefügt.',
    NOACCOUNTADDEDMESSAGE:
      'Beginnen Sie mit der Integration der Konten zur Verwaltung von Rechnungen und Tarifen',
    ADDACCOUNTNUMBER: 'Hinzufügen',
    SELECTUTILITY: 'Ein Versorgungsgut auswählen',
    ACCNUMBER: 'Kontonummer*',
    UTILITYPROVIDERERROR:
      'Versorgungsanbieter nicht gefunden. Bitte wenden Sie sich an Ihren Honeywell-Manager, wenn Sie Hilfe bei der Konvertierung dieses Kontos benötigen.',
    PASSWORD: 'Passwort*',
    USERNAME: 'Nutzername*',
    SIGNIN: 'Anmeldung',
    UTILITYPROVIDERTOOLTIPTXT:
      'Geben Sie den Namen des Versorgungsgutanbieters ein, wie auf der Betriebsabrechnung angegeben.',
    VERIFICATIONINPROCESS: 'Verifizierung wird durchgeführt',
    VERIFICATIONMSSG1: 'Die Kontoverifizierung dauert zwei bis drei Tage.',
    UPDATECREDENTIALS: 'Anmeldedaten aktualisieren',
    UPDATECREDENTIALSNOTE:
      'Bitte geben Sie Ihr aktualisiertes „Serviceanbietername“-Passwort ein, um Ihr Konto zu aktivieren.',
    ENTERCREDENTIALS: 'Anmeldedaten eingeben',
    ENTERCREDENTIALSNOTE:
      'Bitte verwenden Sie die Anmeldeinformationen für „Serviceanbietername“, um das Konto zu verknüpfen.',
    PLEASEUSESERVICE:
      'Bitte verwenden Sie die Anmeldeinformationen für „Serviceanbieter“, um das Konto zu verknüpfen.',
    FILEEMPTYERRORMSG:
      'Fehler! Die Datei ist leer. Bitte laden Sie sie erneut hoch.',
    FILESIZEERRORMSG:
      'Die Dateigröße überschreitet 50 MB. Verringern Sie die Dateigröße und versuchen Sie es erneut.',
    FILEMAXSIZEERRORMSG:
      'Die Dateigröße überschreitet {maxSize}. Verringern Sie die Dateigröße und versuchen Sie es erneut.',
    FILEHEADERERROR:
      'Die Datei hat ungültige Kopfzeilen. Verwenden Sie die bereitgestellte Vorlage, und laden Sie sie erneut hoch.',
    CSVFILEINVALID:
      'Die Daten/der Name der hochgeladenen CSV-Datei sind/ist ungültig. Prüfen Sie die Datei, und versuchen Sie es erneut.',
    CSVFILEINVALIDNAME:
      'Die hochgeladene CSV-Datei ist ungültig. Sonderzeichen oder mehrfache Erweiterungen sind nicht zulässig.',
    DEACTIVATEACCOUNT: 'Konto deaktivieren',
    DEACTIVATEUDSACCOUNT: 'Deaktivieren Sie den monatlichen Datenservice',
    DEACTIVATEIDSACCOUNT: 'IDS (Intervall-DS) deaktivieren',
    REACTIVATEACCOUNT: 'Konto reaktivieren',
    REACTIVATEIDSACCOUNT: 'IDS (Intervall-DS) reaktivieren',
    CONVERTTOAUTOMATIC: 'In "Automatisch" konvertieren',
    MANAGEBILLDETAILS: 'Rechnungsdetails verwalten',
    MANAGETARIFFDETAILS: 'Tarife verwalten',
    EDITACCOUNTDETAILS: 'Kontodetails bearbeiten',
    EDIT_ACCOUNT_DETAILS: 'Kontodetails bearbeiten',
    ADD_METERS: 'Zähler hinzufügen',
    UTILITY_TYPES: 'VERSORGUNGSGUTTYPEN',
    CONVERT_INTEGRATION_TYPE: 'Konvertierung des Integrationstyps',
    ACCOUNT_NUMBER: 'Kontonummer',
    BILLING_CYCLE: 'Abrechnungszeitraum',
    PERIOD: 'Zeitraum',
    EDITACCOUNTDETAILSTOOLTIP:
      'Der Benutzer kann alle Felder bearbeiten, falls keine Rechnungen hochgeladen wurden.',
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      'Der Benutzer darf die Kontonummer bearbeiten.',
    CONVERTINTRGRATIONTYPE: 'In "Automatisch" konvertieren',
    ENABLEIDS: 'IDS (Intervall-DS) aktivieren',
    DELETE: 'Löschen',
    DELETING: 'Löschen',
    DEACTIVATECONFIRMATIONNOTE:
      'Möchten Sie die Kontonummer wirklich deaktivieren?',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      'Möchten Sie den Intervall-Datenservice (IDS) für die Kontonummer wirklich deaktivieren?',
    REACTIVATECONFIRMATIONNOTE:
      'Möchten Sie die Kontonummer wirklich erneut aktivieren?',
    REACTIVATEIDSCONFIRMATIONNOTE:
      'Möchten Sie den Intervall-Datenservice (IDS) für die Kontonummer wirklich reaktivieren?',
    DEACTIVATEUTILITYACCOUNTMSSG:
      'Sobald das Konto deaktiviert wurde, ruft die Anwendung die Betriebsabrechnungsdaten nicht mehr automatisch ab und es werden lediglich die historischen Daten gespeichert.',
    DEACTIVATEIDSACCOUNTMSSG:
      'Sobald der Intervall-Datenservice (IDS) deaktiviert wurde, ruft die Anwendung die Versorgungsintervalldaten nicht mehr automatisch ab und es werden lediglich die historischen Daten gespeichert.',
    REACTIVATEUTILITYACCOUNTMSSG:
      'Sobald das Konto reaktiviert wird, ruft die Anwendung automatisch die Informationen zur Betriebsabrechnung auf.',
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Sobald das Konto reaktiviert wird, ruft die Anwendung automatisch die Versorgungsintervalldaten ab.',
    YES: 'Ja',
    NO: 'Nein',
    REVERIFYNOTE:
      'Bitte geben Sie die Anmeldeinformationen für „Serviceanbieter“ ein, um das Konto zu verknüpfen.',
    REVERIFYHEADER: 'Anmeldedaten und Kontonummer bestätigen',
    REVERIFY: 'Erneut prüfen',
    UPDATE: 'Aktualisieren',
    REENROLL: 'Konto reaktivieren',
    save: 'SPEICHERN',
    ACCOUNTMISSINGHEADER: 'Kontonummer aktualisieren',
    ACCOUNTMISSINGNOTE:
      'Bitte geben Sie die Anmeldedaten und die Kontonummer des „Serviceanbieters“ ein, um das Konto zu verknüpfen.',
    SHOWMORE: 'Mehr anzeigen',
    NORESULTS: 'Keine Ergebnisse gefunden.',
    BREAKDOWNBYSITE: 'Analyse nach Standort ({count})',
    PORTFOLIOENERGY: 'Energie',
    PORTFOLIOENERGYCONS: 'Energieverbr.',
    PORTFOLIOCONSUMTION: 'Verbrauch',
    PORTFOLIOWATER: 'Wasser',
    PORTFOLIOWATERCONS: 'Wasserverbr.',
    ENERGYUSAGEBYSITE: 'Energieverbrauch nach Standorten ({count})',
    SITEWITHDATA: '* Nur Standorte mit Daten werden in der Tabelle angezeigt',
    ELECTRICITYUSAGEBYSITE: 'Stromnutzung nach Standorten ({count})',
    GASUSAGEBYSITE: 'Gasnutzung nach Standorten ({count})',
    WATERUSAGEBYSITE: 'Wassernutzung nach Standorten ({count})',
    ENERGYOPTIMIZATION: 'Intelligente Gebäudeoptimierung',
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Intelligente Gebäudeoptimierung (IBO)',
    ENERGYOPTIMIZATIONSAVINGS: 'Einsparungen bei IBO',
    EOSETTINGSUBTITLE:
      'EO überwacht, misst und optimiert die HVAC-Technik im Gebäude kontinuierlich, um in allen Situationen den geringsten Energieverbrauch zu erreichen. Dabei wird der Energieaufwand für die Heizung und Kühlung eines Gebäudes kontinuierlich minimiert.',
    EOSETTINGMODALHEADER: 'Energieoptimierung inaktiv?',
    EOSETINGMODALCONTENT:
      'Energy Optimization überwacht, misst und optimiert HVAC in Ihrer Einrichtung nicht kontinuierlich, um den niedrigsten Energieverbrauch zu erreichen.',
    EOSETINGMODALCONTENTSUB:
      'Möchten Sie die Energieoptimierung wirklich inaktivieren?',
    EOENABLETITLE: 'Aktivieren Sie die Energieoptimierung für diesen Standort.',
    EOSTATUSMESSAGESUCCESS:
      'Energy Optimization wurde für diesen Standort erfolgreich aktiviert.',
    EOSTATUSMESSAGEERROR:
      'Energy Optimization wurde für diesen Standort erfolgreich deaktiviert.',
    EOSETTINGNODATAAVAILABLE:
      'Wenden Sie sich an den Systemadministrator. Die Konfiguration ist noch nicht abgeschlossen.',
    CURRENTEOSTATUS: 'Aktueller EO-Status: ',
    ON: 'Ein',
    OFFMANUALSWITCHEDOFF: 'Aus - manuell ausgeschaltet',
    OFFLINE: 'Offline',
    EONotOptimizing: 'EO nicht optimiert',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Aus - planmäßig ausgeschaltet zur Verbesserung der Baseline',
    SwitchedOfffromCloud: 'Vom Cloud-Server ausgeschaltet',
    SwitchedOfffromSite: 'Vom Standort ausgeschaltet',
    EOON:
      'Der EO-Ein-Status zeigt die momentan verwendete Optimierungsstrategie an',
    EOMANUALSWITHCHEDOFF:
      'Der Sollwert wurde seit der manuellen Ausschaltung des EO nicht mehr angewendet',
    PLANNEDOFFFORBASELINE:
      'EO wurde zur Verbesserung der Baseline geplant ausgeschaltet',
    STATUSNOTAVAILABLE: 'Status nicht verfügbar',
    STATUSNOTAVAILABLETOOLTIP:
      'Statusdetails sind derzeit nicht vorhanden. Bitte wenden Sie sich an das Honeywell-Support-Team -connectedbuildingsupport@honeywell.com, um dieses Problem zu beheben',
    EOOFFLINE:
      'EO-Aus-Status zeigt an, dass die Optimierungsstrategie aufgrund eines Optimierungsfehlers nicht verwendet wird.',
    SwitchedOfffromCloudToolTip:
      'EO wurde vom Cloud-Server ausgeschaltet. Bitte wenden Sie sich an das Honeywell-Support-Team -connectedbuildingsupport@honeywell.com um EO wieder zu aktivieren',
    SwitchedOfffromSiteToolTip:
      'EO wurde manuell vom Benutzer am Standort ausgeschaltet',
    EOSavings: ' Einsparungen bei der Optimierung intelligenter Gebäude',
    EOUtility_all: 'Alle Versorgungsgüter',
    EOUtility_electricity: 'Elektrizität',
    EOUtility_gas: 'Erdgas',
    EOUtility_steam: 'Dampf',
    EOUtility_chilledwater: 'Kaltwasser',
    EOUtility_hotwater: 'Warmwasser',
    inactiveDays: 'Inaktive Tage',
    inactiveDay: 'Inaktiver Tag',
    excludedDays: 'Ausgeschlossene Tage',
    excludedDay: 'Ausgeschlossener Tag',
    activeHours: 'Aktive Stunden',
    activeDay: 'Aktiver Tag',
    savingsSummaryEO:
      'Geschätzte Einsparungen (bei {opertionalPercentage} % EO-Betriebszeit)',
    operationalTimeEO: 'Mit {opertionalPercentage}% EO-Betriebszeit',
    timeUsedForBaselining: '{baseline}% der Zeit für die Baseline verwendet',
    siteComfort: 'Komfort am Standort',
    activeStrategyStatus: 'Aktiv',
    inactiveStrategyStatus: 'Inaktiv',
    lastUpdated: 'Letzte Aktualisierung:',
    CALCULATED: 'Baseline',
    ESTIMATEDSAVINGS: 'Geschätzte Einsparungen',
    OPPORTUNITYFROMEO: 'Möglichkeiten von EO',
    EMAASEOSTATETOOLTIP:
      'Der Status „Aktiv“ oder „Inaktiv“ zeigt die aktuelle verwendete Optimierungsstrategie an.',
    EOSAVINGTOOLTIP:
      'Energieeinsparungen bei Ausführung von Intelligent Building Optimization im Vergleich zum berechneten Energieverbrauch',
    EOSAVINGONENABLE: 'Einsparungen an IBO-aktivierten Tagen',
    EOSAVINGENTIREPERIOD: 'Einsparung über den gesamten Zeitraum',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'Keine Einsparungen innerhalb des ausgewählten Zeitbereichs. Um eine Schätzung der Einsparungen zu erhalten, erweitern Sie die ausgewählte Zeitspanne.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      'Verbrauch, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Basisjahres. EUI wird aus Energiedaten aus den Betriebskostenabrechnungen berechnet.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      'Verbrauch, berechnet für die ausgewählte Dauer aus tatsächlichen Werten bezogen auf die Daten des Vorjahres. EUI wird aus Energiedaten aus den Betriebsabrechnungen berechnet.',
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      'Der Verbrauch wird für die ausgewählte Dauer auf der Grundlage der tatsächlichen Werte im Vergleich zu den Basis- oder den Daten des Vorjahres berechnet. EUI wird aus Energiedaten aus den Betriebsabrechnungen berechnet.',
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      'Die Verwendung wird für den ausgewählten Zeitraum aus den tatsächlichen Daten berechnet, im Vergleich zu den vorherigen oder den Baseline-Daten für das Utility und den Live-Zähler. Die monatliche Nutzung basiert auf dem durchschnittlichen täglichen Energieverbrauch aus den Betriebsabrechnungen, normalisiert für den gesamten Monat, wenn die Rechnung zwei Monate umfasst.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'Die Nutzung wird für die ausgewählte Zeitspanne aus den tatsächlichen Daten im Vergleich zu den Basisdaten des Zählers vor Ort berechnet.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      'Die Nutzung wird für die ausgewählte Zeitspanne aus den tatsächlichen Daten im Vergleich zu den Baseline-Daten aus Versorgungsintervalldaten berechnet.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'Die Nutzung wird für die ausgewählte Zeitspanne aus den tatsächlichen Daten im Vergleich zu den vorherigen Daten des Zählers vor Ort berechnet.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      'Die Nutzung wird für den ausgewählten Zeitraum anhand der tatsächlichen Daten im Vergleich zu den Daten der vorherigen Zeitspanne aus den Betriebsabrechnungen berechnet. Die monatliche Nutzung basiert auf dem durchschnittlichen täglichen Energieverbrauch aus den Betriebsabrechnungen, normalisiert für den gesamten Monat, wenn die Rechnung zwei Monate umfasst.',
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Änderung',
    PORTFOLIOSITECOUNT: 'Analyse nach Standort ({count})',
    UTILITYCOSTBYSITES: 'Kosten für {Utility} nach Standorten ({count})',
    ALLUTILITYCOSTBYSITES: 'Versorgungskosten nach Standorten ({count})',
    SOLAR: 'Solar',
    WIND: 'Wind',
    SOLARPERFORMANCE: 'Solarleistung',
    WINDPERFORMANCE: 'Wind-Leistung',
    UTILITYCOSTOVERVIEW: 'Übersicht über die Versorgungsgüterkosten',
    DESCRIPTIONNOTIFICATION:
      'Sie haben die maximal zulässige Zahl von Versorgungskonten für denselben Versorgungstyp erreicht. Wenden Sie sich an Ihren Administrator, um weitere Konten zu erstellen.',
    TITLENOTIFICATION: 'Die Obergrenze für Konten ist erreicht.',
    ENERGYUSAGECAPS: 'ENERGIEVERBRAUCH',
    UPDATEERRORMESSAGE:
      'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
    MANUALTOAUTOMATICCONVERSION:
      'Die Kontokonvertierung von manuell auf automatisch wurde erfolgreich durchgeführt.',
    APPLY: 'ANWENDEN',
    RESET: 'RÜCKSETZEN',
    CLOSE: 'SCHLIESSEN',
    SCOPE1FUELTYPES: 'Scope 1-Kraftstofftypen',
    SCOPE1FILTERSUBHEADER:
      'Filteränderungen betreffen nur die graphische Anzeige',
    SCOPE1DATAMISSING: 'Scope 1-Daten fehlen',
    SCOPE1SHOWMISSINGDATA:
      'Überprüfen Sie die fehlenden Daten für Scope 1 und aktualisieren Sie diese',
    FUELGASTYPE: 'Kraftstoff-/Gastyp',
    COMPOUNDTYPE: 'Art der Verbindung',
    UTILITYTYPE: 'Art des Versorgungsguts',
    FUELGASTYPESELECT: 'Wählen Sie einen Kraftstoff-/Gastyp',
    COMPOUNDSELECT: 'Wählen Sie einen Verbindungstyp',
    UTILITYSELECT: 'Wählen Sie einen Versorgungsguttyp',
    EMISSIONFACTOR: 'CO2-Emissionsfaktor',
    SelectCategory: 'Kategorie auswählen',
    UNIT: 'Einheit',
    UNITSELECT: 'Wählen Sie eine Einheit',
    StationaryCombustion: 'Stationäre Verbrennung',
    YEAR: 'Jahr',
    Country: 'Land',
    State: 'Bundestaat/-land',
    YEARSELECT: 'Wählen Sie ein Jahr',
    MONTH: 'Monat',
    Override: 'Überschreiben',
    MONTHSELECT: 'Wählen Sie einen Monat',
    ADDDATA: 'Daten hinzufügen',
    NOFUELCONSUMED: 'Kein Kraftstoff verbraucht ',
    NOCONSUMED: 'Kein Verbrauch',
    QUANTITY: 'Menge',
    QUANTITYENTER: 'Menge eingeben',
    COSTSCOPE: 'Kosten',
    COSTENTER: 'Kosten eingeben',
    EDIT: 'Bearbeiten',
    YEARCHECK: 'Jahr',
    MONTHERROR: 'Wählen Sie einen anderen Monat',
    SUCCESS: 'Daten erfolgreich aktualisiert',
    CO2FACTORROOLTIPHEADER: 'CO2-Emissionsfaktor',
    PLEASENOTE: 'Hinweis: ',
    PLEASENOTETEXT:
      'Der neue CO2-Emissionsfaktor wird für die nächste Berechnung der CO2-Emissionen verwendet. Bereits berechnete Co2-Emissionswerte werden mit dem neuen Wert nicht neu berechnet.',
    CO2FACTORROOLTIPCONTENT:
      'Es handelt sich um die Menge an CO2, die pro verbrauchter Energieeinheit in die Atmosphäre freigesetzt wird',
    CO2FACTORSCCONTENT:
      'Es handelt sich um die Menge an CO2, die pro verbrauchter Energieeinheit in die Atmosphäre freigesetzt wird. Geben Sie den Äquivalentwert in kg Co2e/mmbtu für die ausgewählte Einheit ein.',
    CO2FACTORRFCONTENT:
      'Es handelt sich um die Menge an CO2, die pro verbrauchter Energieeinheit in die Atmosphäre freigesetzt wird. Geben Sie den Äquivalentwert in MTCo2e/mmbtu für die ausgewählte Einheit ein.',
    CO2FACTORSCOPETWOANDGASCONTENT:
      'Es handelt sich um die Menge an CO2, die pro verbrauchter Energieeinheit in die Atmosphäre freigesetzt wird. Geben Sie den Äquivalentwert für die ausgewählte Einheit ein.',
    FUELTABLETEXT:
      'Die folgenden Kraftstofftypen gehören zu den Scope 1-Emissionen.',
    METEREDGASHEADER:
      'Die folgenden Versorgungsguttypen gehören zu den Scope 1-Emissionen.',
    SCOPETWOHEADER:
      'Die folgenden Versorgungsguttypen gehören zu den Scope 2-Emissionen.',
    UNITDROPDOWNNAME: 'Einheit',
    COMPOUNDTABLETEXT:
      'Die folgenden Verbindungstypen gehören zu den Scope 1-Emissionen.',
    ENERGYCONSUMPTIONNILM: 'Energieverbrauch',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'Der Graph zeigt den Energieverbrauch und seine Aufschlüsselung über den ausgewählten Zeitraum',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE: 'Energieverbrauch nach Gerätetyp',
    METERNAME: 'Name des Zählers*',
    METERNUMBER: 'Nummer des Zählers*',
    CONSUMPTIONUNIT: 'Verbrauchseinheit',
    DEMANDUNIT: 'Bedarfseinheit',
    CURRENCYUNIT: 'Währungseinheit',
    TOTALMETERS: 'ZÄHLER GESAMT',
    METERNAMECHANGEDESCRIPTION:
      'Nachfolgend finden Sie die Liste der Zähler-IDs, die mit dem Konto verknüpft sind',
    METERNAMEUPDATESUCCESS:
      'Zähler-ID: ({meterId}) wurde erfolgreich als „({meterName})“ benannt.',
    METERNAMECHARACTERS: 'Nur alphanumerische Zeichen verwenden',
    METERNAMEMAXLENGTH: 'Max. Länge: {maxCh} Zeichen',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Überblick über Verbrauch ({rate})',
    DEMAND_OVERVIEW: 'Übersicht über Bedarf {rate}',
    DEMAND: 'Bedarf',
    CONSUMPTION_RATE_OVERVIEW: '{name} Übersicht ({rate})',
    ELECTRICITYBLENDEDRATE: 'Gemischter Stromtarif ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Kostenübersicht ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: 'Stromkosten ({rate})',
    COST: 'Verbrauchsübersicht',
    SUMMARY: 'Zusammenfassung',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Spalten verwalten',
    RESET_ALL_FILTERS: 'Alle Filter zurücksetzen',
    DOWNLOAD_CSV: 'CSV herunterladen',
    DOWNLOAD_PDF: 'PDF anzeigen und herunterladen',
    UTILITY_BILL_ANALYSIS: '{utilityName}-Rechnungsanalyse',
    NOTIFICATIONBOXFORMONTHLY:
      'Zur Analyse der Stromrechnung gehören Ansichten für den Monat und den Abrechnungszeitraum.  Die monatliche Ansicht berechnet die Betriebskosten anteilig von Monatsbeginn bis Monatsende. Beispiel (01. Mai 2022 - 31. Mai 2022). Die Ansicht für den Abrechnungszeitraum berechnet die Betriebskosten gemäß dem tatsächlichen Abrechnungszyklus. Beispiel (22. Mai 2022-22. Juni 2022). Klicken Sie auf den Fakturierungszeitraum, um die Daten nach dem tatsächlichen Fakturierungszyklus angezeigt zu erhalten.',
    SUMMARYTABLEAPIONGOING:
      'Aufrufe einer Übersichtstabelle werden batchweise verarbeitet. Klicken Sie, nachdem alle Tabellendaten geladen wurden.',
    NOTIFICATIONFORBILLINGPERIOD:
      'Die Ansicht für den Fakturierungszeitraum berechnet die Versorgungskosten nach dem tatsächlichen Fakturierungszyklus. Beispiel (22. Mai 2022-22. Juni 2022).',
    VIEW_OVERVIEW: 'Übersicht anzeigen',
    FILE_DELETED_SUCCESSFULLY: 'Datei erfolgreich gelöscht',
    FILE_DELETEING_ERROR:
      'Fehler beim Löschen der Datei. Bitte versuchen Sie es nach einiger Zeit erneut.',
    AVG_CONSUMP_PER_MTH: 'Durchschn. Verbrauch pro Monat',
    AVG_CONSUMP_PER_DAY: 'Durchschn. Verbrauch pro Tag',
    MTHLY_CONSUMP_PER_SQFT: 'Monatlicher Verbrauch pro Quadratfuß',
    EnableIDSText:
      'Geben Sie die Anmeldeinformationen ein, um das Konto zu überprüfen. Klicken Sie auf „Absenden“, um IDS zu aktivieren.',
    EnableIDSHeaderTxt: 'IDS (Intervall-DS) aktivieren',
    EOSAVINGS: 'Einsparungen bei EO',
    EOSUMMARY: 'Zusammenfassung der EO',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Alarmtyp',
    CONFIGUREALARMDESCLINE1:
      'Wählen Sie den Alarmtyp für die zu konfigurierenden Zähler aus',
    CONFIGUREALARMDESCLINE2:
      'Wählen Sie den Alarmtyp für Zähler aus, um Alarme auszulösen, wenn der Energieverbrauch im angegebenen Bereich über die Basislinie steigt.',
    ALLMETERS: 'Alle Zähler ',
    SEARCHALARMTYPE: 'Wählen Sie den Alarmtyp aus',
    SEARCHMETERS: 'Zähler suchen',
    THRESHOLDSETTINGS: 'SCHWELLENWERTEINSTELLUNGEN',
    NOMETERSSELECTED:
      'Wählen Sie mindestens einen Meter auf der linken Seite aus.\nBedienfeld zum Ändern der Schwellenwerte.',
    THRESHOLDALARM: 'SCHWELLENWERTALARM',
    ALARMNAME: 'Alarmname',
    MINTHRESHOLD: 'Unterer Schwellenwert',
    MAXTHRESHOLD: 'Oberer Schwellenwert',
    TO: 'bis',
    RESETTODEFAULTS: 'Auf Standardeinstellungen zurücksetzen',
    SAVE: 'SPEICHERN',
    NOMETERSUNDERSITE: 'Keine Zähler verfügbar',
    NOSITESAVAILABLE: 'Keine Standorte verfügbar',
    VALIDATIONREQUIRED:
      'Es muss mindestens eine Priorität ausgewählt und alle Eingaben darunter müssen ausgefüllt werden',
    VALIDATIONOVERLAPPING:
      'Die eingegebenen Daten sind ungültig oder überschneiden sich mit anderen Werten'
  },
  urjanetStatus: {
    ENROLLED: 'Erfolgreich angemeldet',
    ENROLLEDMSG: 'Extraktion des Kontos war erfolgreich',
    SUCCESSFUL_DELIVERED: 'Erfolgreich zugestellt',
    SUCCESSFUL_DELIVEREDMSG: 'Extraktion und Datenzustellung waren erfolgreich',
    PRODUCTION: 'Produktion',
    PRODUCTIONMSG: 'Das Konto ist in Produktion',
    Active: 'Aktiv',
    ACTIVEMSG:
      'Manuelles Konto vorhanden, und Benutzer kann manuelle Rechnungen eingeben.',
    Enroll_Successful: 'Anmeldung erfolgreich',
    FAILEDLOGIN: 'Anmeldung fehlgeschlagen',
    NEEDSCREDENTIAL: 'Benötigt Anmeldedaten',
    NEEDSCREDENTIALMSG: 'Dem Konto sind keine Anmeldeinformationen zugeordnet',
    FAILEDTOACCESS: 'Zugriff fehlgeschlagen.',
    NEEDSTEMPLATE: 'Vorlage erforderlich',
    NEEDSTEMPLATEMSG:
      'Das Konto hat Anmeldeinformationen, diese haben jedoch keine zugewiesene Vorlage',
    UNDERREVIEW: 'Wird überprüft',
    UNDERREVIEWMSG: 'Fehler mit generischem Status',
    WEBSITEISSUE: 'Website-Problem',
    WEBSITEISSUEMSG: 'Das Konto kann keine Verbindung zur Website herstellen',
    CAPTCHALOGIN: 'Captcha-Anmeldung',
    CAPTCHALOGINMSG:
      'Die Anmeldung wird von einem Captcha auf der Website blockiert',
    TEMPLATEFAILURE: 'Fehler in der Vorlage',
    TEMPLATEFAILUREMSG:
      'Ein Problem mit der Vorlage hat die erfolgreiche Extraktion verhindert',
    NEEDSENROLLMENT: 'Anmeldung erforderlich',
    NEEDSENROLLMENTMSG: 'Das Konto muss angemeldet sein',
    NOBILL: 'Keine Rechnung',
    NOBILLMSG: 'Auf der Website ist keine Rechnung für das Konto verfügbar.',
    REENROLLED: 'Erneut angemeldet',
    REENROLLEDMSG: 'Das Konto wird nach Deaktivierung erneut angemeldet',
    NAVIGATIONFAILURE: 'Navigationsfehler',
    NAVIGATIONFAILUREMSG:
      'Für diese Konten ist eine Vorlagenkorrektur erforderlich',
    SOURCEFORMATCHANGE: 'Änderung des Quellformats',
    SOURCEFORMATCHANGEMSG: 'Es wurde ein neues Rechnungsformat erkannt',
    ACCOUNTNUMBERCHANGE: 'Änderung der Kontonummer',
    ACCOUNTNUMBERCHANGEMSG: 'Die Kontonummer wurde zur neuen Nummer geändert.',
    USERACTIONREQUIRED: 'Benutzeraktion erforderlich',
    USERACTIONREQUIREDMSG: 'Aktion des Kunden erforderlich',
    MIGRATION: 'Migration',
    MIGRATIONMSG:
      'Das Konto wurde mit der neuen Anbieter-/Kontonummer migriert.',
    INITIALTEMPLATEDEVELOPMENT: 'Entwicklung der Anfangsvorlage',
    INITIALTEMPLATEDEVELOPMENTMSG: 'Die Vorlage wird derzeit erstellt.',
    REJECTED: 'Abgelehnt',
    REJECTEDMSG:
      'Konten abgelehnt, da diese nicht für die Verarbeitung gültig sind',
    EBILLENROLLMENT: 'E-Rechnungs-Anmeldung',
    EBILLENROLLMENTMSG:
      'Konto, für das eine E-Rechnungs-Anmeldung erforderlich/ausstehend ist',
    CREDENTIALUPDATED: 'Anmeldeinformationen aktualisiert',
    CREDENTIALUPDATEDMSG:
      'Die Anmeldeinformationen wurden nach dem Fehlschlag aktualisiert, der Prozess zur Kontoprüfung dauert 2 bis 3 Tage.',
    TEMPLATEUPDATED: 'Vorlage aktualisiert',
    TEMPLATEUPDATEDMSG:
      'Die Vorlage wurde aktualisiert, wurde jedoch nicht getestet.',
    UNKNOWN: 'Unbekannt',
    UNKNOWNMSG: 'Kontostatus unbekannt',
    PENDINGMSG: 'Der Kontostatus ist „ausstehend“',
    PENDING: 'Ausstehend',
    DELETED: 'Gelöscht',
    DELETEDMSG: 'Das Konto wurde gelöscht.',
    ENROLLMENTFAILUREMSG: 'Fehler bei der Kontoanmeldung',
    ENROLLMENTFAILURE: 'Anmeldefehler',
    DOESNOTEXIST: 'Ist nicht vorhanden.',
    DOESNOTEXISTMSG: 'Das Konto ist nicht vorhanden',
    ACCOUNTNUMBERMISMATCHMSG: 'Die Kontonummern stimmen nicht überein',
    ACCOUNTNUMBERMISMATCH: 'Fehlende Übereinstimmung der Kontonummer',
    CONVERSIONINPROGRESS: 'Konvertierung wird durchgeführt',
    CONVERSIONINPROGRESSMSG:
      'Kontokonvertierung von manuell zu automatisch wird durchgeführt',
    FAILEDTOACCESSMSG:
      'Die Extraktion ergab kein Ergebnis (möglicherweise eine neue Website oder fehlerhafte Navigation)',
    FAILEDTOACCESSMSGIDS:
      'Zugriff auf Versorgungsintervalldaten fehlgeschlagen',
    FAILEDLOGINMESSAGE:
      'Die Navigation ist beim Anmeldeschritt fehlgeschlagen (Benutzer/Kennwort prüfen)',
    ACCOUNTMISSING: 'Konto fehlt',
    ACCOUNTMISSINGMESSAGE:
      'Die Anmeldeinformationen wurden ausgeführt und waren in gewissem Umfang erfolgreich, dieses Konto wurde jedoch nicht gefunden.',
    CONNECTIONERROR: 'Verbindungsfehler',
    CONNECTIONERRORMESSAGE:
      'Es ist ein Fehler aufgetreten. Bitte geben Sie die Anmeldedaten für „Versorgungsanbieter“ für das Konto erneut ein.',
    CONNECTIONERRORMESSAGEIDS: 'Etwas ist schiefgelaufen.',
    BLOCKED: 'Konto gesperrt',
    BLOCKEDMESSAGE: 'Anmeldung gesperrt.',
    INACTIVE: 'Konto inaktiv',
    INACTIVEMESSAGE: 'Das Konto ist inaktiv.',
    FINALLED: 'Konto geschlossen',
    FINALLEDMESSAGE:
      'Überprüfen Sie das Konto und kündigen Sie es, wenn es nicht mehr verarbeitet werden muss.',
    VERIFICATIONINPROG: 'Verifizierung wird durchgeführt',
    VERIFICATIONINPROGIDS: 'Überprüfung wird durchgeführt',
    REENROLLMENTPROG: 'Erneute Anmeldung wird durchgeführt',
    REACTIVATIONPROG: 'Reaktivierung wird durchgeführt',
    SUBMITTED: 'Abgesendet',
    SUBMITTEDMSG: 'Anfangszustand der Konten; automatisch fortfahren.',
    NOMINATEDPROG: 'Nominiert',
    METERSMISMATCHED: 'Zählerdetails stimmen nicht überein',
    METERSMISMATCHEDMSG:
      'Die Zählerdetails stimmen nicht überein. Bitte aktualisieren Sie die Daten unter „Kontodetails bearbeiten“.',
    VERIFICATIONINPROGMESSAGE:
      'Die Kontoverifizierung dauert zwei bis drei Tage.',
    VERIFICATIONINPROGMESSAGEIDS:
      'Die Kontoverifizierung dauert zwei bis drei Tage.',
    REENROLLMENTTOOLTIP:
      'Der Vorgang der erneuten Anmeldung dieses Kontos wird nach Deaktivierung wieder gestartet',
    REACTIVATIONTOOLTIP:
      'Die Reaktivierung dieses IDS-Kontos wird nach der Deaktivierung erneut gestartet',
    NOMINATEDMESSAGE:
      'Das Konto hat vollständig bereitgestellte Anmeldeinformationen, die noch nicht verwendet wurden',
    DATAUNAVAILABLE: 'Abrechnung fehlgeschlagen',
    STATEMENTMISSING: 'Abrechnung fehlt',
    DATAUNAVAILABLEMESSAGE:
      ' Es wurde eine Abrechnung extrahiert, diese konnte jedoch aufgrund von Auditfehlern, Speicherfehlern o. dgl. nicht gespeichert werden.',
    STATEMENTMISSINGMSG:
      'Die Anmeldeinformationen wurden ausgeführt und waren erfolgreich und das Konto war auf der Website zu sehen, es konnte jedoch keine Abrechnung extrahiert werden',
    NOTENROLLED: 'Nicht angemeldet',
    NOTENROLLEDMESSAGE:
      'Die Extraktion des Kontos war erfolgreich, das betreffende Konto ist jedoch nicht abonniert',
    DEACTIVATED: 'Deaktiviert',
    DEACTIVATEDMESSAGE: 'Das Konto ist nicht mehr aktiv.',
    REVIEWACCOUNTANDUNS:
      'Überprüfen Sie das Konto und kündigen Sie es, wenn es nicht mehr verarbeitet werden muss',
    ERROR: 'Fehler',
    ERRORMESSAGE:
      'Etwas ist schiefgelaufen. Bitte wenden Si sich an Ihren Administrator.',
    LOGINFAILURE: 'Fehler bei der Anmeldung',
    LOGINFAILUREMESSAGE:
      'Die Anmeldung ist aufgrund einer Kennwortänderung oder eines Ablaufdatums für das Serviceanbieter-Konto fehlgeschlagen.',
    DEACTIVATIONINITIATEDMSSG: 'Deaktivierung gestartet.',
    DEACTIVATIONINITIATED: 'Deaktivierung wird durchgeführt',
    REENROLLEDREQUIRED: 'Erneute Anmeldung erforderlich',
    REENROLLEDREQUIREDMSG:
      'Für das Konto ist eine erneute Zulassung erforderlich. Geben Sie die Anmeldedaten erneut ein, indem Sie auf "Aktualisieren" klicken.',
    ENABLEIDSMSG: 'IDS (Intervall-DS) wurde erfolgreich aktiviert.',
    INTERVALSNOTSUPPORTED: 'Nicht unterstützt',
    INTERVALSNOTSUPPORTEDMSG:
      'IDS wird von dem Versorgungsanbieter für dieses Konto nicht unterstützt.',
    PLUGNEWACCOUNTMSG: 'Konto erfolgreich angemeldet',
    PLUGEMAILAPPROVALMSG:
      'Die Kontoverifizierung ist im Gange und Arcadia benötigt die Genehmigung per E-Mail vom Kunden',
    PLUGCREDENTIALISSUEMSG:
      'Fehler beim Zugriff auf Versorgungsintervalldaten aufgrund eines Anmeldeproblem',
    PLUGNODATAAVAILABLEMSG:
      'Fehler beim Zugriff auf Versorgungsintervalldaten, da keine Daten verfügbar sind',
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      'Fehler beim Zugriff auf Versorgungsintervalldaten, da die Genehmigung per E-Mail nicht erfolgreich war',
    PLUGINVALIDCREDENTIALSMSG:
      'Verbindungsfehler aufgrund ungültiger Anmeldeinformationen'
  },
  virtualMeters: {
    SELECTED: 'Stromzähler - Ausgewählt ({count})',
    SEARCHMETERS: 'Zählername suchen',
    METERGROUPDETAILS: 'DETAILS DER ZÄHLERGRUPPE',
    METERGROUPNAME: 'Name der Zählergruppe',
    DESCRIPTION: 'Beschreibung',
    DESCRIPTIONPLACEHOLDER: 'Max. 240 Zeichen',
    VALIDATIONREQUIRED:
      'Es müssen mindestens zwei Zähler ausgewählt und beide Eingaben ausgefüllt werden',
    SAVE: 'SPEICHERN',
    CANCEL: 'ABBRECHEN'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Emissionen gesamt',
    TOTALEMISSION: 'Gesamtemission',
    SCOPEONETITLE: 'CO2-Emissionen nach Scope 1',
    SCOPETWOTITLE: 'CO2-Emissionen nach Scope 2',
    SCOPE1: 'Scope 1',
    SCOPE2: 'Scope 2',
    SCOPEONEDATANOTCONSIDER: 'Scope 1-Daten müssen aktualisiert werden',
    CARBONTITLE: 'Übersicht über CO2-Emissionen',
    PORTFOLIOCARBONTITLE: 'CO2-Emissionen des Portfolios (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      'Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres.',
    CARBONTOOLTIPSUTILITYDETAIL:
      'Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf der bereitgestellten Versorgungsrechnung.',
    CARBONTOOLTIPLIVEDETAIL:
      'Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres vom Zähler vor Ort. Echtzeit-C02-Berechnungen basieren auf dem Hauptzähler.',
    CARBONTOOLTIPINTRVALDETAIL:
      'Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf den Versorgungsintervall-Daten.',
    SCOPEONETOOLTIP:
      'Direkte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres.',
    SCOPETWOTOOLTIP:
      'Indirekte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres.',
    SCOPEONETOOLTIPUTILITY:
      'Direkte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf der bereitgestellten Versorgungsrechnung.',
    SCOPEONETOOLTIPINTERVAL:
      'Direkte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf den Versorgungsintervall-Daten.',
    SCOPEONETOOLTIPLIVE:
      'Direkte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres vom Zähler vor Ort. Echtzeit-C02-Berechnungen basieren auf dem Hauptzähler.',
    SCOPETWOTOOLTIPdUTILITY:
      'Indirekte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf der bereitgestellten Versorgungsrechnung.',
    SCOPETWOTOOLTIPINTERVAL:
      'Indirekte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres. Tatsächliche CO2-Emissionsberechnungen basieren auf den Versorgungsintervall-Daten.',
    SCOPETWOTOOLTIPLIVE:
      'Indirekte Emissionen, berechnet für die ausgewählte Dauer von tatsächlichen Werten bezogen auf die Daten des Vorjahres vom Zähler vor Ort. Echtzeit-C02-Berechnungen basieren auf dem Hauptzähler.',
    CARBONDETAILKEY: 'carbondetail',
    SCOPEONEKEY: 'detailSummaryWithoutCurrency',
    UTILITYDETAILKEY: 'utilitydetail',
    METER: 'ZÄHLER',
    METERNAME: 'NAME DES ZÄHLERS',
    FUELTYPE: 'KRAFTSTOFFTYP',
    SITES: 'STANDORTE',
    SOURCE: 'QUELLE',
    CURRENTAVOIDANCE: 'DERZEITIGE VERMEIDUNG',
    PREVIOUSAVOIDANCE: 'VORHERIGE VERMEIDUNG',
    UTILITYTYPE: 'ART DES VERSORGUNGSGUTS',
    ACTUALEMISSION: 'TATSÄCHLICHE EMISSIONEN',
    ACTUALEMIS: 'TATSÄCHLICHE EMISS.',
    PREVIOUSEMISSION: 'VORHERIGE EMISSIONEN',
    PREVIOUSPERIOD: 'VORHER. EMISS.',
    PREVIOUSEMISSIONS: 'Vorherige Emissionen',
    PORTFOLIOPREVIOUSConsumption: 'VORHERIGE ZEITSPANNE',
    PORTFOLIOACTUALEMISSION: 'TATSÄCHLICHE EMISSIONEN',
    PORTFOLIOPREVIOUSEMISSION: 'VORH. EMISSIONEN',
    PORTFOLIOPREVIOUSCOST: 'VORH. KOSTEN',
    CHANGE: 'ÄNDERUNG',
    ACTUALCONS: 'TATSÄCHLICHER VERBRAUCH',
    BASELINECONSP: 'BASELINE-VERBRAUCH',
    PREVPERIOD: 'VORH. ZEITSPANNE',
    CHANGEPERCENT: 'ÄNDERUNG IN %',
    EUICURRENT: 'EUI DERZEIT',
    EUIPRVPERIOD: 'EUI VORHERIGE ZEITSPANNE',
    PORTFOLIOACTUALCOST: 'TATSÄCHLICHE KOSTEN',
    SAVINGS: 'EINSPARUNGEN',
    FuelType: 'Kraftstofftyp',
    Emissions: 'EMISSIONEN',
    CARBONAVOIDANCE: 'CO2-Vermeidung',
    carbonEmissionsAvoidance: 'Vermeidung von CO2-Emissionen',
    TOTALAVOIDANCETOOLTIP:
      'CO2-Vermeidung, berechnet für die ausgewählte Dauer aus den tatsächlichen Daten gegenüber den Daten des Vorjahrs.',
    Meters: 'Zähler',
    ActivePower: 'Aktive Leistung',
    ActivePowerContent:
      'Die Momentanleistung wird für einen bestimmten Moment gemessen.',
    AVGpower: 'Durchschnittsleistung',
    PeakPower: 'Spitzenleistung',
    PeakPowerContent:
      'Maximaler Leistungsbedarf für die Datumsbereichsauswahl.',
    LoadType: 'Lasttyp',
    LoadTypeContent: 'Lasttyp, dem der Zähler zugeordnet ist.',
    FifteenMinuteElectricConsumption: '15 Min. Verbr.',
    FifteenMinuteElectricConsumptionPrediction: '15 Min. Vorh.',
    ElectricityConsumption: 'Gesamtenergieverbrauch',
    EnergyConsSelectedPeriod: 'Energieverbrauch Ausgewählte Zeitspanne',
    EnergyConsToday: 'Energieverbrauch Heute',
    EnergyConsTodayContent: 'Gesamter Energieverbrauch für heute.',
    EnergyConsMonth: 'Energieverbrauch Monat',
    EnergyConsMonthContent: 'Gesamter Energieverbrauch des aktuellen Monats.',
    TotalEnergyConsumption: 'Gesamtenergieverbrauch',
    TotalEnergyConsumptionContent: 'Gesamtverbrauch von Zählern',
    EnergyConsSelectedPeriodContent: 'Energieverbrauch Ausgewählte Zeitspanne',
    DataQuality: 'Datenqualität',
    BaselineQuality: 'Baseline-Qualität',
    PowerDemand: 'Strombedarf',
    APPLYBASELINEFROMDATEINVALID:
      'Wählen Sie ein Datum aus, das nicht früher als die letzten 15 Tage liegt.',
    INVALIDEXCLUSIONRANGESELECTION:
      'Wählen Sie das Ausschlussdatum innerhalb des ausgewählten Trainingszeitraums aus.'
  },
  NILM: {
    NILMModalHeader: 'Registrierung für NILM',
    NILMMeterDetails: 'NILM-Details hinzufügen',
    SmartXMeter: 'Vorschau',
    NILMDetailsTabHeader:
      'Bitte geben Sie Ihre NILM-Zählerdetails (Nonstrusive Load Monitoring, nicht-eindringliche Lastüberwachung) ein, um diese in HBSM hinzuzufügen.',
    NILMDetailsTabSubHeader: 'Details des NILM-Zählers',
    NILMMeterId: 'Daten-ID/UUID',
    NILMDISAGGREGATEDMETERID: 'Desaggregierte Daten-ID/UUID (optional)',
    NILMMeterName: 'Name des Zählers',
    NILMAddMeter: 'Zähler hinzufügen',
    NIMAssignMainMeter: 'Als Hauptzähler zuweisen',
    NILMNextButton: 'Weiter',
    NILMSubmitButtom: 'Absenden',
    NILMCancelButton: 'Abbrechen',
    NILMcardheader: 'Non-Intrusive Load Monitoring (NILM)',
    NILMcardsubheader:
      'Legen Sie die Aufschlüsselung des Energieverbrauchs Ihres Standorts nach den Gerätetypen fest',
    NILMRedirect: 'Sie werden in 5 Sek. umgeleitet',
    NILMAccountVerification: 'Kontoverifizierung läuft',
    NILMAccountVerificationSuccess: 'Kontoverifizierung erfolgreich',
    INVALIDNILMMETERID: 'Zähler-Installations-ID ungültig',
    METERNAMEINVALID: 'Zählername ist für den Standort bereits vorhanden',
    NILMMainmeter: '(als Hauptzähler zugewiesen)',
    NILMsmartXmeterheader:
      'Nachfolgend finden Sie Ihre NILM-Zähler. Bitte überprüfen, um fortzufahren und auf „Absenden“ klicken',
    NILMDUPLICATEMETERNAME: 'Doppelter Zählername',
    NILMDUPLICATEMETERID: 'Doppelte Zähler-ID',
    IDDUPLICATETOGETHER: 'ungültige und doppelte UUID',
    NAMEDUPLICATETOGETHER: 'Zählername bereits vorhanden und doppelt'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'Für den 12-monatigen Zeitraum bis -',
    NoRecordsFound: 'Keine Datensätze gefunden',
    LearnText: 'Mehr erfahren',
    outOfHundred: '/100',
    CurrentScore: 'Aktuelle Bewertung',
    EnergyTooltipHeader: 'Energieverbrauch',
    EnergyTooltipContent:
      'Die Energy-Star-Bewertung ist ein Maß dafür, welche Leistung Ihr Objekt im Vergleich zu ähnlichen Objekten erbringt, wenn es für Klima- und Betriebseigenschaften normalisiert wird.',
    EnergyStarTitle: 'Energy-Star-Bewertung',
    loading: 'Laden',
    ViewText: 'Bewertungsdetails anzeigen',
    NA: 'N/A',
    SomethingWentWrong: 'Hinweis',
    notifyServerError:
      'Auf dem Server ist ein Fehler aufgetreten. Wenden Sie sich an den Systemadministrator.',
    ReasonForNoScoreLabel:
      'Die Energy Star-Bewertung konnte aufgrund von einigen technischen Fehlern nicht geladen werden.',
    ViewReasonForNoScore: 'Grund für fehlende Bewertungsdetails anzeigen',
    EnergyStarNoScoreNote:
      'The Energy Star score displayed is from {prevMonth}, as the previous month score is unavailable.',
    EnergyStarNoScoreNoContentMessage:
      'Kein Grund für fehlende Bewertungsinformationen gefunden!',
    EnergyStarNoScoreForLastMonthLabel:
      'Die Energy Star-Bewertung für den vorigen Monat konnte nicht geladen werden. Daher wird die Bewertung aus dem letzten Monat angezeigt.'
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '"{fileName}" ist ein ungültiges Dateiformat. Nur das Dateiformat .{extension} wird akzeptiert',
    INVALIDFILE_EXTENSION:
      'Ungültige Dateierweiterung, bitte verwenden Sie eine gültige .{extension}-Datei.',
    INVALIDFILE_MIME:
      'Ungültiger Datei-MIME-Typ, bitte verwenden Sie eine Datei mit gültigen MIME-Typen {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE: 'Die Dateigröße muss kleiner als {size} sein',
    INVALIDFILE_MINALLOWEDSIZE: 'Die Dateigröße muss größer als {size} sein',
    INVALIDFILE_UNKNOWNERROR:
      'Beim Zugriff auf die Dateiinformationen ist ein Fehler aufgetreten. Validierung nicht möglich.',
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'Die hochgeladene Excel-Datei enthält ungültige Spalten. Verwenden Sie die entsprechende Vorlage, und laden Sie die Excel-Datei erneut hoch.',
    INVALID_SCHEMA_LIST_REQ_HEADERS:
      'Erforderliche Kopfzeilen: {requiredSubHeaders}',
    EMPTY: '',
    NO_DATA: 'Die Datei enthält keine Daten',
    INVALID_DATA_CONTENT:
      'Die erste Datenzeile muss ein Raum-Element enthalten',
    SOME_ERROR_EXCEL_READ:
      'Beim Lesen der Excel-Datei ist ein Fehler aufgetreten. Fehler: {errorString}',
    SOME_ERROR_GENERAL:
      'Es ist ein Fehler aufgetreten. Wählen Sie erneut eine gültige Datei aus, und laden Sie sie hoch. Fehlerdetails -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Ungültiger Datentyp. Erlaubt: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'Der Name hat ein ungültiges Sonderzeichen.',
    NAME_INVALID_MAX_LEN: 'Maximal {len} Zeichen erlaubt',
    SPATIAL_ELE_NEW: 'Neuer Bereich wird erstellt',
    NO_ASSOC_REMOVE:
      'Kein VAV/Belegungssensor zugeordnet. Entfernen Sie diesen Eintrag.',
    PROPERTIES_INVALID: 'Einige Eigenschaften sind ungültig',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      'Für die bereitgestellte Raumelement-ID ({id}) stimmen der Name vom Blatt und der im Standort ({dbSpEleName}) registrierte nicht überein.',
    ELEMENT_NAME_MISMATCH:
      'Für die bereitgestellte Element-ID ({id}) stimmen der Name vom Blatt und der am Standort ({dbEleName}) registrierte nicht überein',
    DUPLICATE_ENTRIES: 'Mehrere Einträge mit diesem Namen',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'Für den Standort sind mehrere Geräte mit diesem Namen registriert. Bitte benennen Sie dieses Gerät zum Zuordnen in einen eindeutigen Namen um.',
    ELEMENT_ID_DNE: '{type} mit der angegebenen ID ({id}) ist nicht vorhanden',
    SPATIAL_ELEMENT_ID_DNE:
      'Bereich mit der angegebenen ID ({id}) ist nicht vorhanden',
    ELEMENT_TYPE_NAME_DNE: '{type} mit diesem Namen ist nicht vorhanden.',
    PROPERTY_DNE:
      'Eigenschaft mit dem Namen {name} ist nicht vorhanden. Bitte prüfen'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO: 'ZLO Equipment Space Mapping und Konfiguration',
    UPLOAD_CARD_DESC_ZLO:
      'Hochladen von Gerätedaten zu Space Mapping Data for ZLO Onboarding and Configuration',
    UPLOAD_MODAL_TITLE: 'ZLO Onboarding Data hochladen',
    VALIDATE_DATA: 'Hochladen',
    BACK_TO_UPLOAD: 'Zurück',
    UPLOAD_TAB_TOP_NOTE:
      'Bitte laden Sie die Vorlage herunter und füllen Sie die Details zum Raum-Element zusammen mit den gerätebezogenen Details in der Vorlage aus, bevor Sie mit dem Hochladen fortfahren.',
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'XLSX-Vorlage herunterladen',
    UPLOAD_TAB_SECOND_NOTE:
      '(Es ist immer nur ein Upload gleichzeitig möglich)',
    UPLOAD_TAB_PLACEHOLDER: 'Datei hierhin ziehen und ablegen',
    VALIDATING_FILE_DATA: 'Validierung der Dateidaten',
    READING_FILE: 'Lesen der Datei',
    VALIDATING_FILE_SCHEMA: 'Validierung des Dateischemas',
    RETRIEVING_SITE_DATA: 'Abruf der Standortdaten zur Validierung',
    VALIDATING_DATA_ENTRIES: 'Validierung der Daten',
    ALL_ENTRIES_VALID: 'Alle Eingaben sind gültig',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Klicken Sie auf „Absenden“, um fortzufahren und sich in HBSM zu registrieren.',
    VIEW_ALL_ENTRIES: 'Alle Eingaben anzeigen',
    FIX_VAL_ERRORS_MSG:
      'Nachfolgend finden Sie die fehlerhaften Einträge zu ZLO-Onboarding und Konfigurationsdaten. Bitte gehen Sie zurück zur Registerkarte „Hochladen“ und laden Sie die Excel-Datei ohne die fehlerhaften Einträge erneut hoch, um sich bei HBSM zu registrieren.',
    VAL_OK_SUBMIT_MSG:
      'Klicken Sie auf „Absenden“, um fortzufahren und sich in HBSM zu registrieren.',
    ERROR_BOX_TEXT:
      '{numErrors} Fehler identifiziert. Bitte korrigieren Sie diese und laden Sie die Datei erneut hoch, um sie bei HBSM einzureichen und zu registrieren.',
    VALIDATION_ERROR_TITLE: 'Fehler bei der Validierung',
    TOTAL: 'Gesamt',
    CURRENTLY_SHOWING: 'Anzeige von {num} von {total} insgesamt',
    SHOW_ALL_ENTRIES: 'Alle Eingaben anzeigen',
    SL_NO: 'Sl. Nein',
    SPATIAL_ELE_NAME: 'Name des Raum-Elements',
    ELE_TYPE: 'Elementtyp',
    ELE_NAME: 'Name',
    ZLO_STATE: 'ZLO-Zustand',
    ZO_SETBACK: 'Zone Optimization Setback (F)',
    VAV: 'Variables Luftvolumen',
    OCCUPANCY_SENSOR: 'Belegungssensor',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'Belegungssensor',
    SEARCH_PLACEHOLDER: 'Suche',
    SEARCH_MIN_LEN: 'Min. {len} Zeichen',
    NO_DATA: 'Keine Daten entsprechen Ihrer Suche',
    VALIDATING_TITLE: 'Validierung der hochgeladenen Datei',
    SOME_ERROR_FETCHING_DATA:
      'Beim Abruf der Standortdaten ist ein Fehler aufgetreten. Fehler: {errorString}',
    SUBMITTING_TITLE:
      'Bitte warten Sie, während wir die Ausrüstung den Räumen zuordnen.',
    SUBMITTING_SUBTITLE: 'Sie werden in wenigen Sekunden umgeleitet.',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Erstellen neuer Räume',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS: 'Zuordnung von Geräten zu Räumen',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      'Beim Zuordnen des Elements zum Raum-Element ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
    UPDATING_PROPERTIES: 'Aktualisieren der Eigenschaften',
    SUBMISSION_SUCCESS_TITLE: 'Zuordnung von Ausrüstung zu Raum erfolgreich',
    SUBMISSION_ERROR_TITLE: 'Fehler beim Senden der Daten',
    SUBMISSION_ERROR_MESSAGE:
      'Beim Senden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
    BULK_CREATION_ERROR_MESSAGE:
      'Beim Erstellen der Raum-Elemente ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Beim Aktualisieren der Eigenschaften ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    SUBMISSION_SUCCESS_SUBTITLE:
      'Die den Räumen zugeordneten VAV- und Anwesenheitssensoren werden auf der Registerkarte der Ausrüstung auf der Standort-Startseite wiedergegeben.',
    GOTO_SITE_HOME_PAGE: 'Zur Standort-Startseite',
    'Items per Page': 'Zeilen pro Seite'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'Die nachfolgenden Informationen werden immer gemäß dem Fakturierungsinformationszyklus angezeigt'
  },
  UtilityBuilder: {
    NEWBILL: 'Neue Rechnung',
    ENTERDATAMANUALLY: 'Manuelle Eingabe der Daten',
    BILLNAME: 'Rechnungsname',
    BILLINGDATE: 'Rechnungsdatum',
    TOTAL_BILL_AMOUNT: 'Gesamtbetrag der Rechnung',
    BILLING_PERIOD_CONSUMPTION: 'Verbrauch im Abrechnungszeitraum',
    BILLING_DEMAND: 'Abrechnungsbedarf',
    ENTER_PLACEHOLDER: 'Eingeben',
    SELECT_PLACEHOLDER: 'Auswählen',
    CATEGORIES: 'Kategorien',
    ACCOUNTNUMBER: 'Kontonummer',
    UTILITYTYPE: 'Art des Versorgungsguts',
    BILLINGCYCLE: 'Fakturierungszyklus',
    UPLOADELECTRICITYBILL: 'Stromrechnung hochladen',
    UPLOADGASBILL: 'Gasrechnung hochladen',
    ADDELECTRICITYBILL: 'Stromrechnung hinzufügen',
    ADDGASBILL: '{utilityType}-Rechnung hinzufügen',
    UPLOADUTILITYBILL: 'Betriebsabrechnung hochladen',
    PDFUPLOADPROMPT: 'Laden Sie eine PDF-Datei der Betriebsabrechnung hoch.',
    UploadElectricitybill: 'Stromrechnung hochladen*',
    Utilitybill: 'Betriebsabrechnung',
    UPLOADBILL: 'Rechnung für {utilityType} hochladen',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Stromrechnung hochladen',
    FILENAMECONTAINSPACES: 'Dateiname enthält Leerzeichen.',
    FILENAMECONTAINSPECIALCHARACTER: 'Der Dateiname enthält Sonderzeichen.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Rechnungskategorien',
    REFERSAMPLEBILL: 'Siehe Beispiel-Rechnung.',
    INPUTCATEGORIES:
      'Bitte geben Sie die verschiedenen Kategorien und die zugehörigen Kosten aus Ihrer {utilityType}-Rechnung ein. Falls Sie Hilfe benötigen, um diese auf der Rechnung zu finden, '
  },
  baseline: {
    baselineconfiguration: 'Baseline-Konfiguration',
    baselineConfigDesc:
      'Angepasste Baselines stellen den erwarteten Verbrauch des Versorgungsguts für einen Standort auf der Grundlage einer Kombination aus historischem Verbrauch, aktuellen Trends und bekannten Faktoren wie etwa Wettervariablen fest.',
    baseline: 'Baseline',
    total: 'Gesamt',
    searchPlaceholder: 'Suche nach',
    create: 'Baseline erstellen',
    view: 'Baseline anzeigen',
    baselineQuality: 'Baseline-Qualität',
    baselinePeriod: 'Basiszeitraum',
    reportingPeriod: 'Berichtszeitraum',
    estBaselinePeriod: 'Baseline-Zeitraum einrichten',
    baselinePeriodDescription:
      'Wählen Sie die Baseline-Zeitspanne und die Berichtszeitspanne aus, für den Sie eine Baseline erstellen müssen.',
    independentVariables: 'Unabhängige Variablen',
    autoSelectBest: 'Autom. Auswahl der besten Variablen',
    utilityDataType: 'Utility-Datentyp',
    calendarMonth: 'Kalendermonat',
    billingPeriod: 'Fakturierungszeitraum',
    tStat: 'T-Stat'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'KONTO HINZUFÜGEN',
    ADD_METERS: 'ZÄHLER HINZUFÜGEN'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Gesamtbetrag der Rechnung',
  Consumption: 'Verbrauch',
  Demand: 'Bedarf',
  'Service Charges': 'Servicegebühren',
  'Transmission & Distribution': 'Übertragung und Verteilung',
  Others: 'Andere',
  'Demand Charges': 'Bedarfsgebühren',
  'Total Cost': 'Gesamtkosten',
  Total: 'Gesamt'
};
